import React, { useState } from "react";
import TradingViewWidget from "../components/TradingViewWidget";
import { Card, Overline } from "../components/Primitives";
import { LineChart, Newspaper, Globe2 } from "lucide-react";

const CHARTS = [
  { label: "Nifty 50", symbol: "NSE:NIFTY" },
  { label: "Sensex", symbol: "BSE:SENSEX" },
  { label: "Reliance", symbol: "NSE:RELIANCE" },
  { label: "HDFC Bank", symbol: "NSE:HDFCBANK" },
  { label: "S&P 500", symbol: "SPREADEX:SPX" },
  { label: "Nasdaq 100", symbol: "NASDAQ:NDX" },
  { label: "Gold", symbol: "TVC:GOLD" },
  { label: "Bitcoin", symbol: "BINANCE:BTCUSDT" },
  { label: "Ethereum", symbol: "BINANCE:ETHUSDT" },
];

export default function Markets() {
  const [symbol, setSymbol] = useState(CHARTS[0].symbol);

  return (
    <div className="space-y-5">
      <Card className="p-0 overflow-hidden" testid="ticker-tape">
        <TradingViewWidget type="ticker-tape" height={46} config={{
          symbols: [
            { proName: "NSE:NIFTY", title: "Nifty 50" },
            { proName: "BSE:SENSEX", title: "Sensex" },
            { proName: "NSE:BANKNIFTY", title: "Bank Nifty" },
            { proName: "SPREADEX:SPX", title: "S&P 500" },
            { proName: "NASDAQ:NDX", title: "Nasdaq 100" },
            { proName: "TVC:GOLD", title: "Gold" },
            { proName: "BINANCE:BTCUSDT", title: "Bitcoin" },
            { proName: "BINANCE:ETHUSDT", title: "Ethereum" },
            { proName: "FX_IDC:USDINR", title: "USD/INR" },
          ],
          showSymbolLogo: true, displayMode: "adaptive",
        }} />
      </Card>

      <div className="grid lg:grid-cols-3 gap-5">
        <Card className="lg:col-span-2 p-4" testid="advanced-chart-card">
          <div className="flex items-center gap-2 mb-3 flex-wrap">
            <LineChart className="w-4 h-4 text-[#00e5ff]" /><Overline>Live Terminal Chart</Overline>
            <div className="flex gap-1 flex-wrap ml-auto">
              {CHARTS.map((c) => (
                <button key={c.symbol} data-testid={`chart-sym-${c.symbol}`} onClick={() => setSymbol(c.symbol)}
                  className={`px-2.5 py-1 rounded font-mono text-[11px] transition-colors ${symbol === c.symbol ? "bg-[#00e5ff] text-[#06121a]" : "border border-[#2d3c59] text-[#94a3b8] hover:text-[#f8fafc]"}`}>{c.label}</button>
              ))}
            </div>
          </div>
          <TradingViewWidget type="advanced-chart" height={480} config={{
            symbol, interval: "D", timezone: "Asia/Kolkata", style: "1",
            allow_symbol_change: true, hide_side_toolbar: false, withdateranges: true, calendar: false,
          }} />
        </Card>

        <Card className="p-4" testid="market-overview-card">
          <div className="flex items-center gap-2 mb-3"><Globe2 className="w-4 h-4 text-[#818cf8]" /><Overline>Market Overview</Overline></div>
          <TradingViewWidget type="market-overview" height={480} config={{
            showChart: true, dateRange: "12M", showFloatingTooltip: true,
            tabs: [
              { title: "Indian", symbols: [{ s: "NSE:NIFTY" }, { s: "BSE:SENSEX" }, { s: "NSE:BANKNIFTY" }, { s: "NSE:RELIANCE" }, { s: "NSE:TCS" }] },
              { title: "Global", symbols: [{ s: "SPREADEX:SPX" }, { s: "NASDAQ:NDX" }, { s: "TVC:GOLD" }, { s: "TVC:SILVER" }] },
              { title: "Crypto", symbols: [{ s: "BINANCE:BTCUSDT" }, { s: "BINANCE:ETHUSDT" }, { s: "BINANCE:SOLUSDT" }] },
            ],
          }} />
        </Card>
      </div>

      <Card className="p-4" testid="news-card">
        <div className="flex items-center gap-2 mb-3"><Newspaper className="w-4 h-4 text-[#00e676]" /><Overline>Market News & Events</Overline></div>
        <div className="grid lg:grid-cols-2 gap-4">
          <TradingViewWidget type="timeline" height={420} config={{ feedMode: "market", market: "stock", displayMode: "regular" }} />
          <TradingViewWidget type="timeline" height={420} config={{ feedMode: "all_symbols", displayMode: "regular" }} />
        </div>
      </Card>
      <p className="text-center text-[11px] text-[#64748b] font-mono">Live charts & news via TradingView · delayed feeds may apply</p>
    </div>
  );
}
